module.exports = __webpack_public_path__ + "img/leg-left-front.bfd4abbc.png";